<template>
  <div>
    <v-data-table
      v-model="selectedItens"
      :loading="loadingTable"
      :headers="headers"
      :items="reserves"
      class="elevation-1"
      :page-count="numberOfPagesPaginate"
      :page="currentPagePaginate"
      :server-items-length="totalStagesPaginate"
      :options.sync="options"
      :footer-props="{
        itemsPerPageText: 'Itens por pagina',
        itemsPerPageOptions: [5, 10, 15],
        showFirstLastPage: true,
      }"
      @click:row="selectItem"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Reservas de Salões</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-badge
            class="mr-2"
            :content="bagFilter"
            :value="bagFilter"
            bordered
            color="error"
            overlap
          >
            <v-btn
              class="ml-2"
              rounded
              outlined
              large
              color="primary"
              @click="dialogFilter = true"
            >
              <v-icon>{{ icons.mdiFilter }}</v-icon>Filtros
            </v-btn>
          </v-badge>
          <v-text-field
            v-model="search"
            class="mr-2"
            placeholder="Proucurar ID, Hóspede, Empresa, Solicitante ou Localizador externo"
            :append-icon="icons.mdiMagnify"
            single-line
            label="Localizar"
            outlined
            filled
            rounded
            dense
            hide-details
            @click:append="searchItems()"
            @change="searchItems()"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            dark
            rounded
            class="mb-2"
            @click="showDialogNewGuest()"
          >
            <v-icon small>
              {{ icons.mdiPlus }}
            </v-icon>
            Nova Reserva
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.start_time="{ item }">
        {{ formatDate(item.start_time) }}
      </template>

      <template v-slot:item.end_time="{ item }">
        {{ formatDate(item.end_time) }}
      </template>

      <template v-slot:item.status="{ item }">
        <v-chip
          v-if="item.status == 'confirmed'"
          color="info"
        >
          {{ reserved(item) }}
        </v-chip>
        <v-chip
          v-if="item.status == 'precheckin'"
          :color="preCheckinComplete(item) ? '#6CBF84' : '#FB8C00'"
          :text-color="preCheckinComplete(item) ? '#1F4D2E' : '#FFFFFF'"
        >
          {{ reserved(item) }}
        </v-chip>
        <v-chip
          v-if="item.status == 'checkin'"
          color="success"
        >
          {{ reserved(item) }}
        </v-chip>
        <v-chip
          v-if="item.status == 'checkout'"
          color="error"
        >
          {{ reserved(item) }}
        </v-chip>
        <v-chip
          v-if="item.status == 'canceled'"
          color="secondary"
        >
          {{ reserved(item) }}
        </v-chip>
        <v-chip
          v-if="item.status == 'no-show'"
          color="warning"
        >
          {{ reserved(item) }}
        </v-chip>
      </template>

      <template v-slot:item.actions="{ item }">
        <div style=" white-space: nowrap;">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="item.status != 'canceled'"
                icon
                :loading="item.loading_print"
                :disabled="item.loading_print"
                class=""
                color="secondary"
                v-bind="attrs"
                @click="printItem(item)"
                v-on="on"
              >
                <v-icon>
                  {{ icons.mdiPrinter }}
                </v-icon>
              </v-btn>
            </template>
            <span>Imprimir</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="primary"
                class=""
                v-bind="attrs"
                @click="editItem(item)"
                v-on="on"
              >
                <v-icon>
                  {{ icons.mdiPencilOutline }}
                </v-icon>
              </v-btn>
            </template>
            <span>Editar</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="item.status != 'canceled'"
                icon
                color="error"
                v-bind="attrs"
                :disabled="item.status != 'confirmed'"
                @click="cancelItem(item)"
                v-on="on"
              >
                <v-icon>
                  {{ icons.mdiCloseCircleOutline }}
                </v-icon>
              </v-btn>
            </template>
            <span>Cancelar</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="item.status == 'confirmed'"
                icon
                color="success"
                v-bind="attrs"
                @click="payment(item)"
                v-on="on"
              >
                <v-icon>
                  {{ icons.mdiCurrencyUsd }}
                </v-icon>
              </v-btn>
            </template>
            <span>Adiantamento</span>
          </v-tooltip>
        </div>
      </template>

      <template v-slot:no-data>
        <NoDataTable></NoDataTable>
      </template>
      <template v-slot:loading>
        Carregando...
      </template>
    </v-data-table>

    <v-card class="mt-2">
      <v-card-item>
        <v-card-subtitle>
          Clique no registro para visualizar a observação:
        </v-card-subtitle>
      </v-card-item>
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            class="text-center"
          >
            <p v-text="selectedItens.length>0 ?selectedItens[0].obs:''"></p>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- DIALOG FILTRO -->
    <v-dialog
      v-model="dialogFilter"
      width="700"
    >
      <v-card>
        <BarTitleDialog
          title="FILTROS"
          @close="dialogFilter = false"
        />
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-select
                v-model="filter.status"
                clearable
                outlined
                label="Status"
                :items="itemsStatus"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-row>
            <v-col class="text-left">
              <v-btn
                text
                color="error"
                x-large
                @click="clearFilter()"
              >
                limpar filtros
              </v-btn>
            </v-col>
            <v-col class="text-right">
              <v-btn
                text
                color="secondary"
                x-large
                @click="dialogFilter = false"
              >
                FECHAR
              </v-btn>
              <v-btn
                color="primary"
                class="ml-2"
                x-large
                @click="confirmFilter()"
              >
                aplicar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG CANCELAR RESERVA -->
    <v-dialog
      v-model="dialogCancel"
      max-width="500px"
    >
      <v-card>
        <BarTitleDialog
          title="Cancelar reserva"
          @close="dialogCancel = false"
        />
        <v-card-title class="text-h5 text-center">
          <v-row no-gutters>
            <v-col>Deseja realmente cancelar ?</v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-textarea
                v-model="justifyCancel"
                outlined
                label="Justificativa"
                rows="3"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            large
            color="blue darken-1"
            text
            @click="dialogCancel = false"
          >
            fechar
          </v-btn>
          <v-btn
            large
            color="error"
            :loading="loadingCancel"
            @click="cancelItemConfirm()"
          >
            Sim
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <DialogReserve
      v-model="dialogNewGuest"
      :in_data="editedItem"
      :title="formTitle"
      @out_data="saveConfirm"
    />
    <!-- <MsgDelete v-model="dialogDelete" message="Deseja realmente cancelar ?" @delete-yes="cancelItemConfirm()" /> -->
  </div>
</template>

<script>

// import MsgDelete from '@/components/MsgDelete.vue'
import {
  mdiClose,
  mdiDeleteOutline,
  mdiPencilOutline,
  mdiPlus,
  mdiCloseCircleOutline,
  mdiPrinter,
  mdiCurrencyUsd,
  mdiFilter,
  mdiMessageOutline,
} from '@mdi/js'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import NoDataTable from '@/components/NoDataTable.vue'
import DialogReserve from './_components/DialogReserve.vue'
import BarTitleDialog from '@/components/BarTitleDialog.vue'

export default {
  components: {
    NoDataTable,
    DialogReserve,
    BarTitleDialog,
  },
  data: () => ({
    selectedItens: [],
    loadingUserAdmin: false,
    userAdmin: false,
    cancelCashId: null,
    loadingOpenedCashs: false,
    cashItems: [],
    loadingCancel: false,
    justifyCancel: '',
    dialogCancel: false,
    dialogFilter: false,
    filter: {},
    search: '',
    dialogNewGuest: false,
    loadingTable: false,
    totalStagesPaginate: 0,
    numberOfPagesPaginate: 0,
    currentPagePaginate: 0,
    dialogDelete: false,
    dialog: false,
    loading: false,
    itemsStatus: [
      { text: 'Checkin', value: 'checkin' },
      { text: 'Checkout', value: 'checkout' },
      { text: 'Cancelado', value: 'canceled' },
      { text: 'Confirmado', value: 'confirmed' },
      { text: 'Pré Check-in', value: 'precheckin' },
      { text: 'No-Show', value: 'no-show' },
    ],
    headers: [
      {
        text: 'ID',
        align: 'start',
        value: 'id',
      },
      {
        text: 'EMPRESA',
        value: 'company.fantasy_name',
      },
      {
        text: 'SOLICITANTE',
        value: 'resquester',
      },
      {
        text: 'Nº PAX',
        value: 'n_pax',
      },
      {
        text: 'SALÃO',
        value: 'common_area.description',
      },

      {
        text: 'INÍCIO',
        value: 'start_time',
      },
      {
        text: 'TÉRMINO',
        value: 'end_time',
      },
      {
        text: 'STATUS',
        value: 'status',
      },

      {
        text: '',
        align: 'end',
        value: 'actions',
        sortable: false,
      },
    ],
    reserves: [],
    editedIndex: -1,
    editedItem: {},
    editedDefault: {
      check_in: '',
      check_out: '',
      company_id: '',
      room: [],
      tariff_manual: 'not',
      with_iss: 'not',
    },
    commonArea: [],
    options: {},
    tab: null,
    icons: {
      mdiPencilOutline,
      mdiDeleteOutline,
      mdiPlus,
      mdiClose,
      mdiCloseCircleOutline,
      mdiPrinter,
      mdiCurrencyUsd,
      mdiFilter,
      mdiMessageOutline,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Nova Reserva' : 'Editar Reserva'
    },
    bagFilter() {
      if (this.filter.status == null) {
        delete this.filter.status
      }

      return Object.keys(this.filter).length
    },
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
    dialogDelete(val) {
      val || this.closeDelete()
    },
    options: {
      handler() {
        this.initialize()
      },
    },
  },

  created() {
    this.loadCommonArea()
  },

  methods: {
    ...mapActions('events_reserve', [
      'getAll',
      'cancelReserve',
    ]),

    ...mapActions('select', ['loadCommonArea']),
    initialize() {
      this.loadingTable = true
      this.selectedItens = []
      const { page, itemsPerPage } = this.options

      const payload = {
        itemsPerPage: itemsPerPage || 10,
        page,
        search: this.search,
        filter: this.filter,
      }
      this.getAll(payload)
        .then(response => {
          this.reserves = response.data.data
          this.totalStagesPaginate = response.data.total
          this.numberOfPagesPaginate = response.data.last_page
          this.currentPagePaginate = response.data.current_page
        })
        .finally(() => {
          this.loadingTable = false
        })
    },
    searchItems() {
      this.options = {}
      this.initialize()
    },

    clearFilter() {
      this.filter = {}
    },
    confirmFilter() {
      this.initialize()
      this.dialogFilter = false
    },

    editItem(item) {
      this.editedIndex = this.reserves.indexOf(item)
      this.editedItem = item
      this.dialogNewGuest = true
    },

    saveConfirm(reserve) {
      this.initialize()
    },

    cancelItem(item) {
      this.justifyCancel = ''
      this.dialogCancel = true
      this.editedItem = item
    },

    cancelItemConfirm() {
      const index = this.reserves.indexOf(this.editedItem)
      const data = {
        id: this.editedItem.id,
        justify_cancel: this.justifyCancel,
        cancel_cash_id: this.cancelCashId,
      }
      this.loadingCancel = true
      this.cancelReserve(data)
        .then(response => {
          Object.assign(this.reserves[index], response.data)
          this.dialogCancel = false
          this.$toast.success('Cancelado com sucesso !')
        })
        .catch()
        .finally(() => {
          this.loadingCancel = false
        })
    },

    showDialogNewGuest() {
      this.dialogNewGuest = true
    },
    reserved(item) {
      switch (item.status) {
        case 'confirmed':
          return 'Confirmado'
        case 'precheckin':
          return 'Pré Check-in'
        case 'checkin':
          return 'Checkin'
        case 'checkout':
          return 'Checkout'
        case 'canceled':
          return 'Cancelado'
        case 'no-show':
          return 'No-Show'
      }
    },
    preCheckinComplete(item) {
      const total = Number(item.pre_checkin_total_guests) || 0

      return total === 0 || Number(item.pre_checkin_completed_guests) >= total
    },

    printItem(reserve) {
      reserve.loading_print = true
      this.printVoucher(reserve)
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]))
          const fileLink = document.createElement('a')

          fileLink.href = fileURL
          fileLink.setAttribute('download', 'voucher.pdf')
          document.body.appendChild(fileLink)
          fileLink.click()
        })
        .catch(response => {
          console.log(response)
        })
        .finally(() => {
          this.reserves.forEach(item => {
            item.loading_print = false
          })

          // armegagem para força a reação do vue
          const backup = this.reserves
          this.reserves = []
          this.reserves = backup
        })
    },
    closeDelete() {
      this.dialogDelete = false
      this.editedIndex = -1
    },
    formatDate(dateTime) {
      if (dateTime) {
        const [date, time] = dateTime.split(' ')
        const [year, month, day] = date.split('-')
        const [hour, minute] = time.split(':')

        return `${day}/${month}/${year} ${hour}:${minute}`
      }
    },
    selectItem(item) {
      this.selectedItens = []
      this.selectedItens.push(item)
    },
  },
}
</script>

<style scoped>
.card-tab {
  min-height: 420px;
  min-width: 736px;
}

.tool_table_fam {
  height: 50px;
}
</style>
